module.exports = __webpack_public_path__ + "static/media/REINFLOW.7e7b72af.png";